export default "__VITE_ASSET__B0QpDJx8__"